"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore

const pageId = exports.pageId = 29844694138;
const slug = exports.slug = 'guides/cms/content/data-driven-content/serverless-functions/getting-started-with-serverless-functions';
// translate-ignore
const navTitle = exports.navTitle = 'Get started with serverless functions';
const title = exports.title = 'Get started with serverless functions';
const name = exports.name = 'Get started with serverless functions';
const metaDescription = exports.metaDescription = 'Create your first serverless function on the HubSpot CMS, and get a response from it.';
const toc = exports.toc = [{
  "depth": 0,
  "id": "prerequisites",
  "label": "Prerequisites",
  "parent": null
}, {
  "depth": 0,
  "id": "1.-create-a-project-locally",
  "label": "1. Create a project locally",
  "parent": null
}, {
  "depth": 0,
  "id": "2.-add-a-serverless-function-to-the-project",
  "label": "2. Add a serverless function to the project",
  "parent": null
}, {
  "depth": 0,
  "id": "3.-upload-the-project-to-hubspot",
  "label": "3. Upload the project to HubSpot",
  "parent": null
}, {
  "depth": 0,
  "id": "4.-test-the-function",
  "label": "4. Test the function",
  "parent": null
}, {
  "depth": 0,
  "id": "5.-invoke-the-function-from-a-website-page",
  "label": "5. Invoke the function from a website page",
  "parent": null
}, {
  "depth": 0,
  "id": "next-steps",
  "label": "Next steps",
  "parent": null
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      h2: "h2",
      ul: "ul",
      li: "li",
      em: "em",
      strong: "strong",
      code: "code",
      pre: "pre",
      img: "img",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      ProductTier,
      Alert,
      Tabs,
      Tab
    } = _components;
  if (!Alert) _missingMdxReference("Alert", true);
  if (!ProductTier) _missingMdxReference("ProductTier", true);
  if (!Tab) _missingMdxReference("Tab", true);
  if (!Tabs) _missingMdxReference("Tabs", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Get started with serverless functions for the CMS"
    }), "\n", (0, _jsxRuntime.jsx)(ProductTier, {
      tiers: ['cms-enterprise']
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Serverless functions provide a way to execute JavaScript through HubSpot on the server-side, preventing it from being exposed to the client. This can be especially important for making API requests that contain sensitive information, such as an API key or other credentials. When the function is invoked, HubSpot executes the function on its back-end, which also means you don't need to provide your own back-end servers to make requests for your CMS website. HubSpot’s serverless functions use the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://nodejs.org/en/about/",
        children: "NodeJS"
      }), " runtime."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "In this guide, you'll walk through creating a simple serverless function that fetches a quote from a third-party service, then displays that quote on a website page. To build and deploy the serverless function to your account, you'll use a HubSpot developer project."
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["While the previously documented method of uploading serverless functions to\nthe design manager is still supported, it's recommended to use developer\nprojects, as they include a private app for easier authentication while also\nallowing for third-party dependencies. The content of this guide has been\nupdated to use the newest method. You can find reference information for\ndesign manager-based serverless functions in the ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/reference/cms/serverless-functions/serverless-functions",
          children: "reference\nsection"
        }), "."]
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For a high-level review of serverless functions, check out the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/content/data-driven-content/serverless-functions/overview",
        children: "serverless functions overview"
      }), ". You can also check out the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://www.youtube.com/watch?v=N0arXQOyfXo",
        children: "HubSpot Developers YouTube channel"
      }), " for a walkthrough of using serverless functions in a CMS project."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Prerequisites"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Before starting this tutorial, you'll need:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["A ", (0, _jsxRuntime.jsxs)(_components.em, {
          children: [(0, _jsxRuntime.jsx)(_components.strong, {
            children: "Content Hub"
          }), " Enterprise"]
        }), " account, or a ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://app.hubspot.com/signup-hubspot/cms-developers",
          children: "CMS developer sandbox account"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["The ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/cms/tools/hubspot-cli/cli-v7#install-the-cli",
          children: "HubSpot CLI"
        }), " (latest version recommended), which will need to be installed and authenticated with the account you're using. To check which accounts are authenticated, you can run ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs accounts list"
        }), ". Learn more about ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/cms/setup/getting-started-with-local-development",
          children: "getting started with local development"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "1. Create a project locally"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Start by creating a project locally so that you can build and deploy it to your account."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the terminal, navigate to the directory where you'll be storing your project using the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "cd"
        }), " command."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "cd Documents/Dev/serverless-function-project\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Run ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs project create"
        }), " to create a new project."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "hs project create\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Follow the terminal prompts to create your project. For the template, select ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Create an empty project (no template)"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/terminal-select-empty-project.png",
        alt: "Terminal prompt option for creating an empty project with no template"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Navigate into the new project directory using the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "cd"
        }), " command. For example, if you named your project ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "my new project"
        }), ":"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "cd my-new-project\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "2. Add a serverless function to the project"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Once your project has been created, open it in your preferred editor, such as ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/cms/setup/install-and-use-hubspot-code-extension",
        children: "VS Code"
      }), ". HubSpot will have automatically created a project directory along with an empty ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "src"
      }), " directory and a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "hsproject.json"
      }), " configuration file. To add a serverless function to the project, create an ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "app"
      }), " directory inside the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "src"
      }), " directory, then add the following directories and files within it:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "app/app.json"
        }), ": the app configuration file."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "app/app.functions"
        }), ": the serverless function directory. You can use any name you'd like, as long as it ends in ", (0, _jsxRuntime.jsx)(_components.code, {
          children: ".functions"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "app/app.functions/function.js"
        }), ": the JavaScript code that will be executed when the function is invoked."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "app/app.functions/serverless.json"
        }), ": the serverless function configuration file."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "app/app.functions/package.json"
        }), ": includes necessary dependencies."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/project-serverless-functions-structure.png",
        alt: "Project structure after adding the above files and folders to the project directory"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Copy the example code below into your respective local ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "app.json"
        }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "function.js"
        }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "serverless.json"
        }), ", and ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "package.json"
        }), " files. Under each ", (0, _jsxRuntime.jsx)(_components.code, {
          children: ".json"
        }), " code block, you'll also find a table containing field definitions."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(Tabs, {
      defaultSelected: "0",
      children: [(0, _jsxRuntime.jsxs)(Tab, {
        tabId: "0",
        title: "app.json",
        children: [(0, _jsxRuntime.jsx)(_components.pre, {
          children: (0, _jsxRuntime.jsx)(_components.code, {
            className: "language-json",
            children: "{\n  \"name\": \"Serverless function app\",\n  \"description\": \"This app runs a serverless function to fetch a quote using the Zen Quotes API.\",\n  \"scopes\": [\"crm.objects.contacts.read\", \"crm.objects.contacts.write\"],\n  \"uid\": \"serverless-function-app\",\n  \"public\": false\n}\n"
          })
        }), (0, _jsxRuntime.jsxs)(_components.table, {
          children: [(0, _jsxRuntime.jsx)(_components.thead, {
            children: (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.th, {
                children: "Field"
              }), (0, _jsxRuntime.jsx)(_components.th, {
                children: "Type"
              }), (0, _jsxRuntime.jsx)(_components.th, {
                children: "Description"
              })]
            })
          }), (0, _jsxRuntime.jsxs)(_components.tbody, {
            children: [(0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.td, {
                children: (0, _jsxRuntime.jsx)(_components.code, {
                  children: "name"
                })
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "String"
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "The name of the app, which will display in HubSpot's UI."
              })]
            }), (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.td, {
                children: (0, _jsxRuntime.jsx)(_components.code, {
                  children: "description"
                })
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "String"
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "The app's description, which will display in HubSpot's UI."
              })]
            }), (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.td, {
                children: (0, _jsxRuntime.jsx)(_components.code, {
                  children: "scopes"
                })
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "Array"
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "The scopes that the app has access to for authenticating requests with the private app access token. The two scopes above are the minimum required scopes. No additional scopes are added for this tutorial, as you won't need to use the private app access token for the request you'll be making."
              })]
            }), (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.td, {
                children: (0, _jsxRuntime.jsx)(_components.code, {
                  children: "uid"
                })
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "String"
              }), (0, _jsxRuntime.jsxs)(_components.td, {
                children: ["The app's unique identifier. This can be any string, but should meaningfully identify the app. HubSpot will identify the app by this ID so that you can change the app's ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "name"
                }), " locally or in HubSpot without removing historical or stateful data, such as logs."]
              })]
            }), (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.td, {
                children: (0, _jsxRuntime.jsx)(_components.code, {
                  children: "public"
                })
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "String"
              }), (0, _jsxRuntime.jsxs)(_components.td, {
                children: ["Set to ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "false"
                }), " for private apps."]
              })]
            })]
          })]
        })]
      }), (0, _jsxRuntime.jsxs)(Tab, {
        tabId: "1",
        title: "function.js",
        children: [(0, _jsxRuntime.jsxs)(_components.p, {
          children: ["This function will fetch a random quote from the ", (0, _jsxRuntime.jsx)(_components.a, {
            href: "https://zenquotes.io/",
            children: "Zen Quotes API"
          }), "."]
        }), (0, _jsxRuntime.jsx)(_components.pre, {
          children: (0, _jsxRuntime.jsx)(_components.code, {
            className: "language-js",
            children: "const axios = require('axios');\n\nexports.main = async (context) => {\n  try {\n    // Make GET request to the ZenQuotes API\n    const response = await axios.get('https://zenquotes.io/api/random');\n\n    // Extract the quote data (first item in the array)\n    const quoteData = response.data[0];\n\n    // Log the quote and author to console\n    console.log(`\"${quoteData.q}\" — ${quoteData.a}`);\n\n    // Return a properly formatted response with status code and body\n    return {\n      statusCode: 200,\n      body: quoteData,\n      headers: {\n        'Content-Type': 'application/json',\n      },\n    };\n  } catch (error) {\n    // Handle any errors that occur during the request\n    console.error('Error fetching quote:', error.message);\n\n    // Return an error response\n    return {\n      statusCode: 500,\n      body: { error: 'Failed to fetch quote' },\n      headers: {\n        'Content-Type': 'application/json',\n      },\n    };\n  }\n};\n"
          })
        })]
      }), (0, _jsxRuntime.jsxs)(Tab, {
        tabId: "2",
        title: "serverless.json",
        children: [(0, _jsxRuntime.jsx)(_components.pre, {
          children: (0, _jsxRuntime.jsx)(_components.code, {
            className: "language-js",
            children: "{\n  \"appFunctions\": {\n     \"quote-function\": {\n      \"file\": \"function.js\",\n      \"secrets\": [],\n      \"endpoint\": {\n        \"path\": \"fetch-quote\",\n        \"method\": [\"GET\"]\n       }\n    }\n  }\n}\n\n"
          })
        }), (0, _jsxRuntime.jsxs)(_components.table, {
          children: [(0, _jsxRuntime.jsx)(_components.thead, {
            children: (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.th, {
                children: "Field"
              }), (0, _jsxRuntime.jsx)(_components.th, {
                children: "Type"
              }), (0, _jsxRuntime.jsx)(_components.th, {
                children: "Description"
              })]
            })
          }), (0, _jsxRuntime.jsxs)(_components.tbody, {
            children: [(0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.td, {
                children: (0, _jsxRuntime.jsx)(_components.code, {
                  children: "quote-function"
                })
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "Object"
              }), (0, _jsxRuntime.jsxs)(_components.td, {
                children: ["An object containing the serverless function's configuration details. This object can have any name, but it must match the associated field name you reference in the ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "appFunctions"
                }), " field in your ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "serverless.json"
                }), " file."]
              })]
            }), (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.td, {
                children: (0, _jsxRuntime.jsx)(_components.code, {
                  children: "file"
                })
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "String"
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "The name of the JavaScript file containing the serverless function code to execute."
              })]
            }), (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.td, {
                children: (0, _jsxRuntime.jsx)(_components.code, {
                  children: "secrets"
                })
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "Array"
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "An array containing names of secrets that the function will use for authenticating requests. For this tutorial, no secrets are needed."
              })]
            }), (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.td, {
                children: (0, _jsxRuntime.jsx)(_components.code, {
                  children: "endpoint"
                })
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "Object"
              }), (0, _jsxRuntime.jsxs)(_components.td, {
                children: ["An object containing details about the endpoint that you can hit to invoke the function. The ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "path"
                }), " field defines the last value in the ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "/hs/serverless/<path>"
                }), " endpoint path, while the ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "method"
                }), " field defines the request method."]
              })]
            })]
          })]
        })]
      }), (0, _jsxRuntime.jsxs)(Tab, {
        tabId: "3",
        title: "package.json",
        children: [(0, _jsxRuntime.jsx)(_components.pre, {
          children: (0, _jsxRuntime.jsx)(_components.code, {
            className: "language-json",
            children: "{\n  \"name\": \"example-serverless-function\",\n  \"version\": \"0.1.0\",\n  \"author\": \"HubSpot\",\n  \"license\": \"MIT\",\n  \"dependencies\": {\n    \"@hubspot/api-client\": \"^7.0.1\",\n    \"axios\": \"^0.27.2\"\n  }\n}\n"
          })
        }), (0, _jsxRuntime.jsxs)(_components.table, {
          children: [(0, _jsxRuntime.jsx)(_components.thead, {
            children: (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.th, {
                children: "Field"
              }), (0, _jsxRuntime.jsx)(_components.th, {
                children: "Type"
              }), (0, _jsxRuntime.jsx)(_components.th, {
                children: "Description"
              })]
            })
          }), (0, _jsxRuntime.jsx)(_components.tbody, {
            children: (0, _jsxRuntime.jsxs)(_components.tr, {
              children: [(0, _jsxRuntime.jsx)(_components.td, {
                children: (0, _jsxRuntime.jsx)(_components.code, {
                  children: "dependencies"
                })
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "Object"
              }), (0, _jsxRuntime.jsx)(_components.td, {
                children: "The dependencies included for the serverless function."
              })]
            })
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "After adding the above code, save your changes."
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "3. Upload the project to HubSpot"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "With your changes saved, you can now upload the project to HubSpot to build and deploy the app and serverless function."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the terminal, run ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs project upload"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "hs project upload\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Confirm that you want to create the project in the account. You won't need to confirm again this for after initial creation. The terminal will display the current status of the build and deploy steps as they progress."
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Once the upload completes, run ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs project open"
        }), " to view the project in HubSpot."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "hs project open\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["In HubSpot, you're able to view the project details, build and deploy logs, serverless function logs, manage the project and app, and more. Learn more about ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/crm/developer-projects/create-a-project#view-the-project-in-hubspot",
        children: "managing projects in HubSpot"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "4. Test the function"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["With the serverless function deployed, you can invoke it by hitting its public URL. Serverless functions built with developer projects have the following public URL structure: ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "https://<domain>/hs/serverless/<endpoint-path-from-config>"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "<domain>"
        }), ": you can use any domain connected to the account. For example, if both website.com and subdomain.brand.com are connected to the account, you could call the function using ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "https://website.com/hs/serverless/<path>"
        }), " or ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "https://subdomain.brand.com/hs/serverless/<path>"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "<endpoint-path-from-config>"
        }), ": the value in the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "path"
        }), " field in ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "serverless.json"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Based on the example code provided in this tutorial, the public URL to invoke the function will be: ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "https://<domain>/hs/serverless/fetch-quote"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "info",
      children: (0, _jsxRuntime.jsx)(_components.p, {
        children: "In the URL to call the function, the endpoint path is global rather than\nscoped to the app or project. If you have identical endpoint paths across\nmultiple apps or projects, the most recently deployed endpoint function will\ntake precedence."
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To view the function's output, navigate to that URL in your browser, replacing the domain with one of your HubSpot-hosted domains. If you haven't connected a custom domain, you can use one of the default domains that HubSpot provides: ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "<hubId>.hs-sites.com"
      }), " (e.g., ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "123456.hs-sites.com"
      }), "). Your browser should display the data returned by the Zen Quotes API."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/zen-quotes-api-return.png",
        alt: "Browser displaying the data returned by the Zen Quotes API"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "5. Invoke the function from a website page"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Now that you've created the serverless function and confirmed that it returns data, implement it into a page to see the data returned in a more realistic context. For this tutorial, you'll create a page template containing some custom JavaScript and HTML to execute the function and display the response data."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "First, create a new page template:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["In your local environment, create a new directory to contain your page template. For the purposes of this tutorial, create this directory outside of the project directory created by ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "hs project create"
          }), "."]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["In the terminal, navigate into that directory using the ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "cd"
          }), " command."]
        }), "\n"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "cd Documents/Dev/serverless-page\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Run ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs create template \"serverless-template\""
        }), " to create a new template named ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "serverless-template"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "hs create template \"serverless-template\"\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Select the ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "page"
        }), " template type."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Open the newly created page template file in your editor, then replace the boilerplate code with the code below. Be sure to replace ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "<domain>"
        }), " in the function endpoint URL (", (0, _jsxRuntime.jsx)(_components.code, {
          children: "fetch('http://<domain>/hs/serverless/fetch-quote')"
        }), ") with a domain that's connected to your HubSpot account."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-html",
        children: "<!--\n    templateType: page\n    label: Serverless function example template\n    isAvailableForNewContent: true\n-->\n<!doctype html>\n<html>\n  <head>\n    <meta charset=\"utf-8\" />\n    <title>{{ content.html_title }}</title>\n    <meta name=\"description\" content=\"{{ content.meta_description }}\" />\n    {{ standard_header_includes }}\n  </head>\n  <body>\n    {% module \"page_template_logo\" path=\"@hubspot/logo\" label=\"Logo\" %}\n    <!-- Button to fetch quote via serverless function -->\n    <div class=\"serverless-container\">\n      <h2>Get quote</h2>\n      <p class=\"subtitle\">Click the button to fetch and display a quote.</p>\n      <button id=\"data-button\" type=\"button\">Get quote!</button>\n      <div id=\"data-container\">\n        <p class=\"data\"></p>\n      </div>\n    </div>\n    <!-- End button section -->\n\n    {{ standard_footer_includes }}\n\n    <!-- JavaScript that invokes the serverless function\n     and adds returned data into the \"data\" text element -->\n    <script>\n      const dataButton = document.getElementById('data-button');\n      const dataContainer = document.getElementById('data-container');\n\n      dataButton.addEventListener('click', function (e) {\n        console.log('Button clicked!');\n\n        // Show loading state\n        dataContainer.innerText = 'Loading...';\n        // Replace <domain> with your own domain\n        fetch('http://<domain>/hs/serverless/fetch-quote')\n          .then((response) => {\n            if (!response.ok) {\n              throw new Error(`HTTP error! Status: ${response.status}`);\n            }\n            // Parse the JSON response\n            return response.json();\n          })\n\n          .then((data) => {\n            console.log('Raw data received:', data);\n\n            // Clear container\n            dataContainer.innerText = '';\n\n            // Create the paragraph element\n            const newDataElement = document.createElement('p');\n            newDataElement.innerText = `\"${data.q}\" — ${data.a}`;\n            dataContainer.appendChild(newDataElement);\n          });\n      });\n    </script>\n  </body>\n</html>\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Save the file, then run ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs upload"
        }), " to upload it to HubSpot. Follow the terminal prompts to select the local source and destination path. For this tutorial, you can just press ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Enter"
        }), " for each prompt to use the default paths."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Next, create a new page from the template in HubSpot."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Navigate to the website pages dashboard of your HubSpot account by running the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs open website-pages"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-shell",
        children: "hs open website-pages\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "info",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["See the full list of available open shortcuts by running ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs open --list"
        }), "."]
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In your browser, click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Create"
        }), " in the upper right to create a new page."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the dialog box, select a ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "domain"
        }), " to use, then assign a ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Page name"
        }), ". The domain of the page will need to match the domain that you're using to invoke the serverless function to avoid cross-origin (CORS) errors. You can either select that domain from the dropdown menu, or update the endpoint URL in the page template code (", (0, _jsxRuntime.jsx)(_components.code, {
          children: "fetch('http://<domain>/hs/serverless/fetch-quote')"
        }), ") to use the domain that you select in this step."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Create page"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["On the template selection screen, search for your new template. You can use the label or the file name to search for the template (e.g., \"Serverless function example page\"). The template will appear under ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Other templates"
        }), ", as it's not part of a theme."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/select-new-template.png",
        alt: "Other templates section showing the newly created page template"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Select template"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["In the page editor, click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Preview"
        }), " in the upper right."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/page-preview.png",
        alt: "Page editor preview button"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Click ", (0, _jsxRuntime.jsx)(_components.strong, {
          children: "Open in a new tab"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "In the new tab, you should now be able to click the button to fetch and display quotes."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2023-24-25/quote-button-demonstration.gif",
        alt: "Demonstration of example button that fetches and displays quotes from the Zen Quotes API"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Next steps"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Now that you've created and implemented a serverless function that interacts with a third-party API, there are a few ways to continue building up your serverless function usage, such as:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.a, {
          href: "/reference/cms/serverless-functions/serverless-functions-in-projects#authentication",
          children: "Including authentication in a request"
        }), " to make calls to HubSpot APIs or other third-party authenticated APIs."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["Implement the button and JavaScript code into a module rather than hardcode it into the page template. This would give you a more portable option, enabling the function to be invoked from any page that the module is added to. To do so, you would create a module, then add the HTML into the module's ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "module.html"
        }), " file, and the JavaScript into the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "module.js"
        }), " file."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(Tabs, {
      defaultSelected: "0",
      children: [(0, _jsxRuntime.jsx)(Tab, {
        tabId: "0",
        title: "module.html",
        children: (0, _jsxRuntime.jsx)(_components.pre, {
          children: (0, _jsxRuntime.jsx)(_components.code, {
            className: "language-html",
            children: "<div class=\"serverless-container\">\n  <h2>Get quote</h2>\n  <p class=\"subtitle\">Click the button to fetch and display a quote.</p>\n  <button id=\"data-button\" type=\"button\">Get quote!</button>\n  <div id=\"data-container\">\n    <p class=\"data\"></p>\n  </div>\n</div>\n"
          })
        })
      }), (0, _jsxRuntime.jsx)(Tab, {
        tabId: "1",
        title: "module.js",
        children: (0, _jsxRuntime.jsx)(_components.pre, {
          children: (0, _jsxRuntime.jsx)(_components.code, {
            className: "language-js",
            children: "const dataButton = document.getElementById('data-button');\nconst dataContainer = document.getElementById('data-container');\n\ndataButton.addEventListener('click', function (e) {\n  console.log('Button clicked!');\n\n  // Show loading state\n  dataContainer.innerText = 'Loading...';\n\n  fetch('http://meowmix-2272014.hs-sites.com/hs/serverless/fetch-quote')\n    .then((response) => {\n      if (!response.ok) {\n        throw new Error(`HTTP error! Status: ${response.status}`);\n      }\n      // Parse the JSON response\n      return response.json();\n    })\n\n    .then((data) => {\n      console.log('Raw data received:', data);\n\n      // Clear container\n      dataContainer.innerText = '';\n\n      // Create the paragraph element\n      const newDataElement = document.createElement('p');\n      newDataElement.innerText = `\"${data.q}\" — ${data.a}`;\n      dataContainer.appendChild(newDataElement);\n    });\n});\n"
          })
        })
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}